// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import analytics from 'universal-ga';
import Vue from 'vue';
import VueCookie from 'vue-cookie';

// get Globa Components
import entityText from '@/components/partials/entityText';
import loader from '@/components/partials/loader';

import App from './App';
import router from './router';
import vuetify from '@/plugins/vuetify';

analytics.initialize('UA-78433887-2');

Vue.config.productionTip = false;

// init Global Components
Vue.component('loader', loader);
Vue.component('entity-text', entityText);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
  },
  VueCookie,
  template: '<App/>',
  components: { App },
});

$(document).on('click', '.menu-mobile li a, .full-container *', function(e){
  $('.mobile-menu').slideUp();
});

$(document).on('click', '.menu-mobile li a, button', function(e){
    setTimeout(calculateMobileTabLiWidth, 500);
});

function calculateMobileTabLiWidth(){
  $('.tab-menu').each(function(e){

    var tabWidth = $(this).width();
    var liCount = $(this).children('li').length;
    var liWidth = (tabWidth -30) / liCount;

    $(this).children('li').css('width', liWidth);

  });
}



// WEBPACK FOOTER //
// ./src/main.js